<template>
  <router-view name="header" />
  <network-alert v-if="failedNetwork" />
  <main id="main-content">
    <router-view />
  </main>
  <router-view name="footer" />
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import NetworkAlert from "@/components/Modal/NetworkAlert";
export default {
  components: { NetworkAlert },
  setup() {
    const { state, dispatch } = useStore();

    const failedNetwork = computed(() => state["tmdbApi"].failedConnection);

    const detectMobile = () => {
      if (window.innerWidth < 768) {
        dispatch("mobileView", true);
      } else {
        dispatch("mobileView", false);
      }
    };

    onMounted(() => {
      window.addEventListener("resize", detectMobile);
      window.addEventListener("load", detectMobile);
    });

    return { failedNetwork };
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Heebo:wght@300;600;900&display=swap");

body {
  font-family: "Heebo", sans-serif !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #000;
}

a {
  text-decoration: none;
}

.bg-secondary {
  background-color: rgba(17, 24, 39, 0.3);
}

.loading_overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 5;
  background: rgba(0, 0, 0, 0.6);
  background-size: cover;
}
/** Skeleton */
.ssc-card {
  width: inherit !important;
}
.ssc-square {
  height: 100% !important;
}
.ssc-wrapper {
  padding: 0 !important;
}
.ssc-circle {
  width: 100% !important;
  height: 100% !important;
}

/** Pagination */
.custom-pagination {
  li > button.Page {
    width: fit-content !important;
    height: auto;
    padding: 5px;
    margin: 0 5px;
    font-size: 1.2rem;
  }
}

/* noUiSlider styles */
.noUi-tooltip {
  display: none !important;
}
.noUi-active .noUi-tooltip {
  display: block;
}
.noUi-connect {
  background: orange !important;
}
.noUi-horizontal {
  height: 9px !important;
  margin: 10px 25px 15px;
}
.noUi-handle {
  box-sizing: border-box !important;
  width: 25px !important;
  height: 25px !important;
  top: -9px !important;
  cursor: pointer !important;
  border-radius: 100% !important;
  transition: all 0.2s ease-out;
  border: 1px solid;
  background: #fff;

  &.noUi-active {
    outline: none !important;
  }
  &.noUi-handle-upper,
  &.noUi-handle-lower {
    outline: none !important;
  }
}

/** Date picker */
.v3dp__datepicker input {
  color: #000;
  padding: 5px;
  font-size: 1rem;
}

.v3dp__datepicker input:focus {
  border: transparent;
  outline: transparent;
}
</style>
